import { ActionType } from 'typesafe-actions';
import BaseReducer, {
	baseInitialState,
} from '../../../../../boilerplate/redux/BaseReducer';
import { IBaseStateType } from '../../../../../boilerplate/redux/types/IBaseStateType';
import { IVendorType } from '../../types/IVendorType';
import * as vendorActions from './vendorActions';

export type VendorAction = ActionType<typeof vendorActions>;

export interface IVendorStateType extends IBaseStateType {
	readonly entryMap: { [queryKey: string]: IVendorType };
	readonly queries: { [queryKey: string]: IVendorType[] };
}

export function vendorReducer(
	state = baseInitialState as IVendorStateType,
	action: VendorAction,
) {
	const Reducer = new BaseReducer('vendorReducer', 'slug');

	return Reducer.extend(state, action, (innerState, innerAction) => {
		switch (innerAction.type) {
			default:
				return innerState;
		}
	});
}
